/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: block;
}`;
export { style };
//# sourceMappingURL=ToggleGroup.style.js.map